import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children, role }) {
  const { user, checked } = useAuth();
  const location = useLocation();

  if (!checked) {
    return (
      <div
        data-testid="auth-checking"
        className="min-h-screen flex items-center justify-center text-slate-400 text-sm tracking-widest uppercase"
      >
        Authenticating…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  if (role && user.role !== role)
    return <Navigate to={user.role === "admin" ? "/admin" : "/portal"} replace />;

  return children;
}
